<template>
	<div
		class="env-card-container"
		:tabindex="tabindex"
		:newEnv="newEnv"
		:compact="compact"
		@click="handleClick($event)"
	>
		<div v-if="!newEnv" class="env-card-state" :state="state" :compact="compact" />
		<div v-if="!compact && !newEnv" class="env-card-info">
			<slot />
		</div>
		<div v-if="newEnv" class="env-card-new" :compact="compact">
			<div class="env-plus-container">
				<Icon name="i-plus" state="dark" :effects="false" size="x-small" />
			</div>
			<p v-if="!compact" class="paragraph-2 fc-dark">New environment</p>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "EnvironmentCard",
	components: {
		Icon
	},
	props: {
		/**
		 * 'light' | 'dark' | 'default' | 'primary' | 'secondary' | 'success' | 'error' | 'warning'
		 */
		state: {
			type: String,
			default: "default",
			validator(value) {
				return [
					"light",
					"dark",
					"default",
					"primary",
					"secondary",
					"success",
					"error",
					"warning"
				].includes(value);
			}
		},
		/**
		 * true | false
		 */
		compact: {
			type: Boolean,
			default: false
		},
		/**
		 * true | false
		 */
		newEnv: {
			type: Boolean,
			default: false
		},
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		}
	},
	methods: {
		handleClick(e) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
$states: (
	"light": var(--dashboard-icon-light),
	"dark": var(--dashboard-icon-dark),
	"default": var(--dashboard-input),
	"primary": var(--dashboard-primary),
	"secondary": var(--dashboard-secondary),
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning)
);

div.env-card-container {
	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-element);
	border-radius: 4px;
	cursor: pointer;

	position: relative;
	&:not([compact]) {
		// max-width: 118px;
		min-height: 70px;
	}
	overflow: hidden;

	&[compact] {
		max-width: 24px;
	}
	&[newEnv] {
		// background-color: var(--dashboard-element-light);
		border: 1px dashed var(--dashboard-border);

		&::before {
			position: absolute;
			content: "";
			width: 100%;
			height: 100%;
			background-color: #000;
			opacity: 0.1;
			z-index: 1;
			border-radius: 4px;
		}
	}

	> * {
		z-index: 2;
	}
	> div.env-card-state {
		height: 4px;

		&[compact] {
			// transition: height 0.3s linear;
			height: 24px;
			width: 24px;
		}

		@each $state, $background in $states {
			&[state="#{$state}"] {
				background: $background;
			}
		}
	}

	> div.env-card-info {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/* height: 100%; */
		flex: 1 1 100%;
		padding: 5px 9px 9px 9px;

		> * + * {
			margin-top: 4px;
		}

		> * {
			max-width: 110px;
		}
	}
	> div.env-card-new {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/* height: 100%; */
		flex: 1 1 100%;
		padding: 4px 8px 8px 8px;

		&[compact] {
			// transition: height 0.3s linear;
			height: 24px;
			padding: 3px 3px 3px 3px;
		}

		// any second child will have top margin 8px
		> * + * {
			margin-top: 8px;
		}
		// evenry child will have z-index 2

		> div.env-plus-container {
			display: inline-flex;
			height: 16px;
			width: 16px;
			border-radius: 8px;
			background-color: var(--dashboard-primary);
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
		}
	}

	&:active,
	&:hover:not(:active) {
		&:before {
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--dashboard-font-dark);
			border-radius: 4px;
		}
	}

	&:active {
		&:before {
			opacity: 0.08;
			cursor: pointer;
		}
	}

	&:hover:not(:active) {
		&:before {
			opacity: 0.04;
		}
	}

	&:focus {
		// > div.env-card-info {
		box-shadow: 0 0 0 2px var(--dashboard-primary);
		outline: none;
		// }
	}

	outline: none;
	// .env-card-animation {
	// 	&-enter {
	// 		transform: translateY(-100%);
	// 	}
	// 	&-leave-active {
	// 		display: none;
	// 	}
	// 	&-enter-active {
	// 		width: 100%;
	// 		transition: transform 0.3s linear;
	// 	}
	// }
}
</style>
